import React from "react";
import styled from "styled-components";
import { Modal, Row, Col, Card, Button } from "antd";
import { CustomLabel } from "../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import "./teleModal.css";

const BookingButton = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 170px;
height: 40px;
border-radius: 40px;
border: solid 2px #f47720;
margin-top: 10px;
margin-right: 20px;
text-align: center;
.ant-btn-text[disabled] {
  color: #f26221 !important;
  font-weight: normal;
}
.ant-btn-text {
  color: #f47720 !important;
  font-weight: normal;
}
&:hover {
  .ant-btn-text[disabled] {
    color: #f47720 !important;
    font-weight: normal;
  }
}
@media (max-width: 768px) {
  width: 140px;
  height: 35px;
  border-radius: 17.5px;
  padding: 12px 2px;
  .ant-btn-text[disabled] {
    font-size: 11px;
  }
  .ant-btn-text {
    font-size: 11px;
  }
}`;

const SubmitButton = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 210px;
height: 40px;
border-radius: 40px;
border: solid 0.5px #f26221;
margin-top: 10px;
text-align: center;
background-image: ${(props) =>
  props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
.ant-btn-text[disabled] {
  color: #f26221 !important;
  font-weight: normal;
}
.ant-btn-text {
  color: white !important;
  font-weight: normal;
}
&:hover {
  background-image: linear-gradient(to top, #f26221, #f5851f);
  .ant-btn-text[disabled] {
    color: white !important;
    font-weight: normal;
  }
}
@media (max-width: 768px) {
  width: 170px;
  height: 35px;
  border-radius: 17.5px;
  padding: 12px 2px;
  .ant-btn-text[disabled] {
    font-size: 11px;
  }
  .ant-btn-text {
    font-size: 11px;
  }
}
`;

const renderProceedBooking = (
  onSubmitHealthDisclosure,
  onBooking,
) => {
  return (
    <Card>
      <Row gutter={[20, 0]}>
        <Col md={24} className="title">
          <CustomLabel font_size="18" font_weight="bold">
            {`Are you sure you wish to go ahead with Appointment Booking?`}
          </CustomLabel>
        </Col>
      </Row>
      <Row className="content-row">
        <CustomLabel font_size="16" font_weight="normal">
          We recommend choosing <b>'Submit Health Disclosure'</b> for faster
          policy decisions and quicker issuance.
        </CustomLabel>
      </Row>
      <Row className="modal-btn-wrapper">
        <Col xs={24} md={12}>
          <div className="justify-flex-center">
            <SubmitButton disable={false}>
              <Button
                onClick={onSubmitHealthDisclosure}
                type="text"
                disabled={false}
              >
                {"Submit Health Disclosure"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </SubmitButton>
          </div>
        </Col>
        <Col xs={24} md={12}>
          <div className="justify-flex-center">
            <BookingButton disable={false}>
              <Button onClick={onBooking} type="text" disabled={false}>
                {"Book Appointment"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </BookingButton>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

const TeleModal = ({
  open,
  onClose,
  onSubmitHealthDisclosure,
  onBooking,
}) => {

  return (
    <Modal
      style={{ top: 20 }}
      open={open}
      onCancel={onClose}
      closable={true}
      destroyOnClose
      zIndex="999"
      footer={null}
    >
      <div className="modal-wrapper-tele">
        {renderProceedBooking(
          onSubmitHealthDisclosure,
          onBooking
        )}
      </div>
    </Modal>
  );
};

export default TeleModal;
